import React from 'react';
import PropTypes from 'prop-types';
import { Button, Stepper } from 'components/Ui';
import { InfinityGreen, ArrowLeftBlue, ArrowRightBlue } from 'images';
import QuickShop from 'images/QuickShop.png';
import StopWatch from 'images/stopwatch.png';
import { useDispatch } from 'react-redux';
import { push } from 'connected-react-router';
import { useIsMobile } from 'utils/hooks';
import { getRegionalBrandName, isAcquisitionDomain } from 'utils/domainHelper';
import { translateData, getToUrl, injectVariables } from 'utils/translation';
import PromotionValidation from './PromotionValidation';
import content from './quickShopContent';
import {
  QUICK_SHOP,
  QUICK_SHOP_COSTCO,
  SELECT_WATER,
  SELECT_EQUIPMENT,
} from './constants';
import styles from './styles.scss';

const Header = ({
  page,
  activeStep,
  stepsArray,
  onNext,
  onBack,
  promotionApplied,
  cartItems,
  isCostco,
  disableNext,
  isPrimaryHeader = true,
  acquisitionVariables,
  ssrReqRoute,
}) => {
  const quickShopContent = isCostco
    ? content[QUICK_SHOP_COSTCO]
    : content[QUICK_SHOP];
  const isSelectWaterPage = page === SELECT_WATER;
  const dispatch = useDispatch();
  const isDisplayOnly = true;
  const regionalBrandName = getRegionalBrandName(ssrReqRoute, 2);
  const teleSaleNumber = injectVariables(
    '{callToOrder}',
    regionalBrandName,
    acquisitionVariables,
    'C1',
  );
  const isSelectEquipmentPage = page === SELECT_EQUIPMENT;
  const isMobile = useIsMobile();
  const isAcquisition = isAcquisitionDomain();
  const isQuickShopBannerHidden = false;
  const renderNextButton = () =>
    isCostco ? (
      <div className={styles.buttonContainer}>
        <Button
          text="NEXT"
          className={styles.navButton}
          onClick={
            isSelectWaterPage
              ? onNext
              : () => dispatch(push(getToUrl(`/cart`, 'U34')))
          }
          icon={<img className={styles.imgRight} src={ArrowRightBlue} alt="" />}
          iconPosition="right"
          disabled={disableNext}
        />
      </div>
    ) : (
      <PromotionValidation
        buttonLabel={stepsArray[activeStep]?.nextButtonText}
        promotionApplied={promotionApplied}
        onNext={onNext}
        step={activeStep}
        cartItems={cartItems}
        reviewCart={!isSelectWaterPage}
        buttonColor="Blue"
        showIcon
      />
    );

  return (
    <div className={!isQuickShopBannerHidden && styles.header}>
      <div className={styles.container}>
        <div className={styles.leftContainer}>
          {isSelectWaterPage ? (
            <div className={styles.titleContainer}>
              {!isPrimaryHeader ? (
                <div className={styles.nextStepText}>
                  {stepsArray[activeStep]?.nextStepText}
                </div>
              ) : isCostco ? (
                <h1 className={styles.title}>
                  <span>Shop</span>
                </h1>
              ) : (
                <div className={styles.title}>
                  <div>
                    <div>Quick</div>
                    <img src={StopWatch} alt="" />
                    <div>Shop</div>
                  </div>
                  <div>
                    {translateData(
                      'A few quick steps to get you set up for your recurring delivery.',
                    )}
                  </div>
                </div>
              )}
            </div>
          ) : (
            <>
              {!isQuickShopBannerHidden && !isMobile && (
                <div className={styles.backButtonContainer}>
                  <Button
                    text="Back"
                    className={styles.navButton}
                    onClick={onBack}
                    icon={
                      <img
                        className={styles.imgLeft}
                        src={ArrowLeftBlue}
                        alt=""
                      />
                    }
                    iconPosition="left"
                  />
                </div>
              )}
            </>
          )}
        </div>
        {!isQuickShopBannerHidden && (
          <>
            <div className={styles.middleContainer}>
              <div className={styles.stepperContainer}>
                <Stepper
                  steps={stepsArray}
                  isCostco={isCostco}
                  activeStep={activeStep}
                  isDisplayOnly={isDisplayOnly}
                  onClick={() => null}
                />
              </div>
            </div>

            <div className={styles.rightContainer}>
              {isMobile && !isSelectWaterPage && (
                <div className={styles.backButtonContainer}>
                  <Button
                    text="Back"
                    className={styles.navButton}
                    onClick={onBack}
                    icon={
                      <img
                        className={styles.imgLeft}
                        src={ArrowLeftBlue}
                        alt=""
                      />
                    }
                    iconPosition="left"
                  />
                </div>
              )}
              {renderNextButton()}
            </div>
          </>
        )}
      </div>
      {!isCostco && teleSaleNumber && (
        <div className={styles.teleMarketing}>
          {translateData(quickShopContent.callToOrder)}
          <a href={`tel:${teleSaleNumber}`}>{teleSaleNumber}</a>
        </div>
      )}
    </div>
  );
};

Header.propTypes = {
  page: PropTypes.string.isRequired,
  activeStep: PropTypes.number,
  stepsArray: PropTypes.array,
  onNext: PropTypes.func,
  onBack: PropTypes.func,
  promotionApplied: PropTypes.bool,
  cartItems: PropTypes.array,
  isCostco: PropTypes.bool,
  disableNext: PropTypes.bool,
  acquisitionVariables: PropTypes.array,
  ssrReqRoute: PropTypes.object,
};

export default Header;
